import type { MisconceptionDefinition } from '../types';
export const klimaatLandschapMisconceptions: MisconceptionDefinition[] = [
// ───────────────────────────────────────────────────────────
// Landschap / gebergte / klimaat
// ───────────────────────────────────────────────────────────
{
  id: 'topo.gebergte-verkeerd-land',
  label: 'Gebergte aan verkeerd land gekoppeld',
  module: 'Topo',
  description: 'Leerling koppelt een gebergte aan het verkeerde land of de verkeerde regio.',
  typicalFamilies: ['TOPO-EU-GEBERGTE', 'TOPO-WERELD-GEBERGTE']
}, {
  id: 'topo.klimaatzone-verward',
  label: 'Klimaatzone verward',
  module: 'Topo',
  description: 'Leerling koppelt een land of regio aan de verkeerde klimaatzone.',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-EU-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-tegenovergesteld',
  label: 'Tegenovergestelde klimaatzone gekozen',
  module: 'Topo',
  description: 'Leerling kiest de tegenovergestelde klimaatzone (bijv. polair waar tropisch hoort, of tropisch waar polair hoort).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-EU-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-kenmerk-verward',
  label: 'Klimaatkenmerk verward',
  module: 'Topo',
  description: 'Leerling verwart kenmerken van klimaatzones (temperatuur, neerslag, seizoenen) tussen verschillende zones.',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-EU-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-breedtegraad-niet-toegepast',
  label: 'Breedtegraad-kennis niet toegepast',
  module: 'Topo',
  description: 'Leerling past de relatie tussen breedtegraad en klimaat niet toe (bijv. Nederland als tropisch of polair classificeren).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-EU-KLIMAAT']
}, {
  id: 'topo.klimaat-neerslag-verkeerd-ingeschat',
  label: 'Neerslagniveau verkeerd ingeschat',
  module: 'Topo',
  description: 'Leerling schat het neerslagniveau van een klimaatzone verkeerd in (bijv. tropisch als droog, of polair als nat).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-bergen-als-hoofdfactor',
  label: 'Bergen gezien als hoofdfactor voor klimaat',
  module: 'Topo',
  description: 'Leerling denkt dat hoogte van bergen de klimaatzone bepaalt in plaats van breedtegraad.',
  typicalFamilies: ['TOPO-KLIMAAT']
}, {
  id: 'topo.klimaat-rivieren-als-hoofdfactor',
  label: 'Rivieren gezien als hoofdfactor voor klimaat',
  module: 'Topo',
  description: 'Leerling denkt dat het aantal of de aanwezigheid van rivieren het klimaat bepaalt in plaats van breedtegraad.',
  typicalFamilies: ['TOPO-KLIMAAT']
}, {
  id: 'topo.klimaat-landgrootte-als-hoofdfactor',
  label: 'Landgrootte gezien als hoofdfactor voor klimaat',
  module: 'Topo',
  description: 'Leerling denkt dat de grootte van een land het klimaat bepaalt in plaats van breedtegraad.',
  typicalFamilies: ['TOPO-KLIMAAT']
}, {
  id: 'topo.klimaat-pool-met-seizoenen',
  label: 'Poolklimaat verward met vier seizoenen',
  module: 'Topo',
  description: 'Leerling denkt dat het poolklimaat vier duidelijke seizoenen heeft (kenmerk van gematigd klimaat).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-pool-met-tropisch',
  label: 'Poolklimaat verward met tropisch',
  module: 'Topo',
  description: 'Leerling denkt dat het poolklimaat warm en regenrijk is (kenmerken van tropisch klimaat).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.klimaat-pool-met-woestijn',
  label: 'Poolklimaat verward met woestijnklimaat',
  module: 'Topo',
  description: 'Leerling verwart het poolklimaat (constant koud) met woestijnklimaat (droog met grote temperatuurverschillen).',
  typicalFamilies: ['TOPO-KLIMAAT', 'TOPO-WERELD-KLIMAAT']
}, {
  id: 'topo.landschapstype-verward',
  label: 'Landschapstype verward',
  module: 'Topo',
  description: 'Leerling kiest het verkeerde landschapstype (bijv. veen i.p.v. duin) bij een Nederlands gebied.',
  typicalFamilies: ['TOPO-NL-LANDSCHAP']
}];